import type { Pinia } from 'pinia'
import { store } from '@/store'
import { emitter } from '@/utils/events'
import { EBizCode } from '@/types/enum'
import type { MessageHandler } from '@/websocket'

/** 与 viewer 中 messageHandler 一致，写入指定 Pinia 的 MyStore */
export function createDeviceWsMessageHandler (pinia: Pinia): MessageHandler {
  return async (payload: { [key: string]: any }) => {
    if (!payload) return

    const myStore = store.other.useMyStore(pinia)

    switch (payload.biz_code) {
      case EBizCode.DeviceUpgrade:
        emitter.emit('deviceUpgrade', payload)
        break
      case EBizCode.DeviceLogUploadProgress:
        emitter.emit('deviceLogUploadProgress', payload)
        break
      case EBizCode.GatewayOsd:
        await myStore.SetGatewayInfo(payload.data)
        break
      case EBizCode.DeviceOsd:
        await myStore.SetDeviceInfo(payload.data)
        break
      case EBizCode.DockOsd:
        await myStore.SetDockInfo(payload.data)
        break
      case EBizCode.DeviceOnline:
        await myStore.SetDeviceOnline(payload.data)
        break
      case EBizCode.DeviceOffline:
        await myStore.SetDeviceOffline(payload.data)
        break
      case EBizCode.FlightTaskProgress:
      case EBizCode.FlightTaskMediaProgress:
      case EBizCode.FlightTaskMediaHighestPriority:
        emitter.emit('flightTaskWs', payload)
        break
      case EBizCode.DeviceHms:
        await myStore.SetDeviceHmsInfo(payload.data)
        break
      case EBizCode.DroneFormat:
        await myStore.SetDeviceCmdExecuteInfo({
          biz_code: payload.biz_code,
          timestamp: payload.timestamp,
          ...payload.data,
        })
        break
      case EBizCode.ControlSourceChange:
      case EBizCode.FlyToPointProgress:
      case EBizCode.TakeoffToPointProgress:
      case EBizCode.JoystickInvalidNotify:
      case EBizCode.DrcStatusNotify:
        emitter.emit('droneControlWs', payload)
        break
      default:
        break
    }
  }
}
